var _desc, _defs, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuyerRating(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.5.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(9.0909 0 0 9.0909 281.8179 235.6897)",
    id: 235163
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(99,106,111)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-26, -20.9259)",
    d: "M 51.5 26.876 V 5.676 a 4.951 4.951 0 0 0 -4.9 -5 H 5.5 a 4.952 4.952 0 0 0 -5 4.9 v 22.1 a 4.95 4.95 0 0 0 4.9 5 H 18.5 l 16 8.5 l -4 -8.5 H 45.9",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(9.0909 0 0 9.0909 611.8182 831.6)",
    id: 496593
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(99,106,111)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(9.0909 0 0 9.0909 611.8182 907.5843)",
    id: 548507
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(99,106,111)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(9.0909 0 0 9.0909 612.7272 661.1454)",
    id: 605845
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(99,106,111)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-62.4, -67.726)",
    d: "M 51.6 65.076 c 2.9 3.2 6.6 5.3 10.9 5.3 c 4.1 0 7.8 -2.1 10.7 -5.2",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(9.0909 0 0 9.0909 615.909 833.8726)",
    id: 790573
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(99,106,111)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-62.75, -86.726)",
    d: "M 26 86.376 a 14.08 14.08 0 0 1 13.5 -10.5 h 4 l 8 -2 c 2.4 4.7 6.1 7.1 11 7 s 8.6 -2.4 11 -7 l 8 2 h 4 a 14.063 14.063 0 0 1 14 14.1 h 0 v 9.6",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(9.0909 0 0 9.0909 613.6363 707.0681)",
    id: 741533
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(99,106,111)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-62.5, -72.7775)",
    d: "M 73.5 64.676 v 9.2 c -2.4 4.6 -6.1 6.9 -11 7 s -8.6 -2.3 -11 -7 v -8.9 c 2.9 3.4 6.6 5.5 11 5.5 S 70.6 68.076 73.5 64.676 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(9.0909 0 0 9.0909 612.2721 833.8726)",
    id: 538600
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(99,106,111)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-62.35, -86.726)",
    d: "M 99.1 86.376 a 14.08 14.08 0 0 0 -13.5 -10.5 h -4 l -8 -2 c -2.4 4.7 -6.1 7.1 -11 7 c -4.9 0 -8.6 -2.4 -11 -7 l -8 2 h -4 a 14.064 14.064 0 0 0 -14 14.1 h 0 v 9.6",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(9.0909 0 0 9.0909 612.7271 476.1452)",
    id: 954136
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(99,106,111)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-62.4, -47.376)",
    d: "M 62.4 70.376 c 11.8 0 18.7 -16.6 18.7 -27.1 s -5.3 -18.9 -18.7 -18.9 s -18.7 8.5 -18.7 18.9 S 50.6 70.376 62.4 70.376 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(9.0909 0 0 9.0909 612.709 369.7817)",
    id: 876732
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(99,106,111)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-62.398, -35.676)",
    d: "M 62.4 41.376 c 3.6 -1.2 8.2 -5.6 11.1 -5.6 c 2.4 0 2.4 5.6 7.1 11.3 a 19.119 19.119 0 0 0 0.5 -4.1 c 0 -10.3 -5.4 -18.7 -18.7 -18.7 s -18.7 8.3 -18.7 18.6 a 8.651 8.651 0 0 0 0.1 1.6 c 0.6 -2.3 1.8 -5.1 3.3 -5.6 C 48.2 38.576 54.7 43.976 62.4 41.376 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(9.0909 0 0 9.0909 277.7272 194.7817)",
    id: 155467
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "rgb(255,90,0)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "-0.05,-10.75 3.45,-3.65 11.35,-2.55 5.65,2.95 6.95,10.75 -0.05,7.15 -7.05,10.75 -5.65,2.95 -11.35,-2.55 -3.55,-3.65 -0.05,-10.75 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyerRating);
export default __webpack_public_path__ + "static/media/buyer-rating.714277e9aa233522b9d8a421a947ba37.svg";
export { ForwardRef as ReactComponent };